module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "toptype": _vm.toptype
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shenbaoA animated fadeInUp"
  }, [_c('div', {
    staticStyle: {
      "border": "2px solid #eee",
      "padding": "30px 30px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex justify-start align-start"
  }, [_c('div', {}, [_c('el-image', {
    staticStyle: {
      "width": "300px",
      "height": "300px",
      "border": "1px solid #eee",
      "display": "block"
    },
    attrs: {
      "src": _vm._f("addurl")(_vm.detail.image),
      "fit": "cover"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "680px",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.detail.company))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "gray",
      "font-size": "18px",
      "margin-bottom": "15px"
    }
  }, [_vm._v(_vm._s(_vm.detail.name))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "gray",
      "font-size": "16px",
      "margin-bottom": "15px"
    }
  }, [_c('i', {
    staticClass: "el-icon-chat-dot-round"
  }), _vm._v(" " + _vm._s(_vm.detail.question_number) + "人咨询")]), _vm._v(" "), _c('div', {
    staticClass: "zbtn pointer",
    on: {
      "click": _vm.shownow
    }
  }, [_vm._v("立即咨询")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "2px solid #eee",
      "margin-top": "20px",
      "border-top": "none"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sd_content"
  }, [(_vm.detail.content) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.detail.content) ? _c('el-empty', {
    attrs: {
      "description": "暂无详细介绍"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('callview', {
    attrs: {
      "text": _vm.config.tech_detail
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box1_header ",
    staticStyle: {
      "margin-bottom": "20px",
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "box1_header_shu"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1_header_text"
  }, [_vm._v("技术服务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "60px",
      "width": "100%",
      "background": "#eee"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "120px",
      "background": "#fff",
      "height": "100%",
      "font-size": "18px",
      "text-align": "center",
      "line-height": "60px",
      "border-top": "2px solid #0070c0"
    }
  }, [_vm._v("详细介绍")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-242fbc16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/techdetail.vue
// module id = 389
// module chunks = 1